import { render, staticRenderFns } from "./license-info-form.vue?vue&type=template&id=babee0aa&scoped=true&"
import script from "./license-info-form.vue?vue&type=script&lang=js&"
export * from "./license-info-form.vue?vue&type=script&lang=js&"
import style0 from "./license-info-form.vue?vue&type=style&index=0&id=babee0aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babee0aa",
  null
  
)

export default component.exports